import { render, staticRenderFns } from "./internal_main.vue?vue&type=template&id=b4f36704&scoped=true&"
import script from "./internal_main.vue?vue&type=script&lang=js&"
export * from "./internal_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f36704",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4f36704')) {
      api.createRecord('b4f36704', component.options)
    } else {
      api.reload('b4f36704', component.options)
    }
    module.hot.accept("./internal_main.vue?vue&type=template&id=b4f36704&scoped=true&", function () {
      api.rerender('b4f36704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/internal_docs/edit/tabs/internal_main.vue"
export default component.exports